export default "__VITE_ASSET__DBLGxOrz__"